import { render, staticRenderFns } from "./CameraView.vue?vue&type=template&id=4511bc4e&"
import script from "./CameraView.vue?vue&type=script&lang=js&"
export * from "./CameraView.vue?vue&type=script&lang=js&"
import style0 from "./CameraView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports